import Icon from '../components/Icon.vue'

Icon.register({
  'question-circle': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M504 256C504 393 393 504 256 504S8 393 8 256C8 119.1 119 8 256 8S504 119.1 504 256zM262.7 90C208.2 90 173.4 113 146.1 153.8 142.6 159 143.8 166.2 148.8 170L183.5 196.3C188.7 200.3 196.1 199.3 200.2 194.2 218 171.5 230.3 158.4 257.5 158.4 277.9 158.4 303.2 171.6 303.2 191.4 303.2 206.3 290.8 214 270.7 225.3 247.1 238.5 216 254.9 216 296V300C216 306.6 221.4 312 228 312H284C290.6 312 296 306.6 296 300V298.7C296 270.2 379.2 269 379.2 192 379.2 134 319 90 262.7 90zM256 338C230.6 338 210 358.6 210 384 210 409.4 230.6 430 256 430S302 409.4 302 384C302 358.6 281.4 338 256 338z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/question-circle.js
// module id = R3SC
// module chunks = 144